export default function checkDeviceRegistered(device, chain_id) {
  const chainMatch = Number(device.chain_id) === chain_id
  return device.device_record_type === 'Device-Media' && chainMatch
}
